<template>
  <DefaultLayout>
    <div class="page-header">
      <h1>Pago Personalizado</h1>
      <p class="subtitle">Realiza un pago único o adquiere tokens adicionales</p>
    </div>

    <Card style="max-width: 500px; margin: 0 auto">
      <template #content>
        <div class="field">
          <label>Descripción</label>
          <InputText v-model="form.description" class="w-full" placeholder="Ej: Tokens adicionales" />
        </div>
        <div class="field">
          <label>Monto (COP)</label>
          <InputNumber v-model="form.amount" class="w-full" :min="1000" prefix="$" />
        </div>
        <Button label="Proceder al pago" icon="pi pi-credit-card" class="w-full mt-3"
          :disabled="!form.description || !form.amount" @click="pay" />
      </template>
    </Card>
  </DefaultLayout>
</template>

<script setup>
import { ref } from 'vue';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import Card from 'primevue/card';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';

const form = ref({ description: '', amount: null });
const pay = () => alert('Integrar con Epayco checkout');
</script>

<style scoped>
.page-header { margin-bottom: 1.5rem; }
.page-header h1 { margin-bottom: 0.25rem; color: #1e293b; }
.subtitle { color: #6b7280; }
.field { margin-bottom: 1rem; }
.field label { display: block; margin-bottom: 0.4rem; font-weight: 500; color: #374151; }
.w-full { width: 100%; }
.mt-3 { margin-top: 0.75rem; }
</style>
